import { useState } from "react"
import { useDispatch } from "react-redux";
import { resetDeviceList } from "../../actions/SelectDevice";

const UseCheckNetworkStatus = () => {
    const dispatch = useDispatch();
    const [offlineStatus, setOfflineStatus] = useState(false);
    const [oneTimeRecheck, setOneTimeRecheck] = useState(false)
    const [onConfirmDeviceClick, setConfirmDeviceClick] = useState(false);
    const [callBMCRedirection, setBMCRedirection] = useState(false);

    const recheckNetworkStatus = () => {
        setOfflineStatus(false)
        setOneTimeRecheck(true)
        setConfirmDeviceClick(false);
        setBMCRedirection(true);
        dispatch(resetDeviceList());
    }

    return {
        offlineStatus,
        oneTimeRecheck,
        onConfirmDeviceClick,
        callBMCRedirection,
        setOfflineStatus,
        setOneTimeRecheck,
        setConfirmDeviceClick,
        setBMCRedirection,
        recheckNetworkStatus
    }
}

export default UseCheckNetworkStatus;